import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Select, Checkbox, Button, DatePicker, Table, Space, Tooltip, InputNumber, Modal } from "antd";
import {
	DataTypeCSTA,
	columns,
	DataTypeCOP,
	columnsCOP,
	DataTypeBank,
	columnsBank,
	initialRecordStatus,
	withCustomerMasterLogic,
	CustomerType,
	IdType,
	ProvinsiType,
	KabupatenType,
	KecamatanType,
	KelurahanType,
	TermOfPaymentType,
	TaxInvoiceType,
	VatTransactionType,
	BusinessType,
	CustomerBehaviourType,
	JobTitleType,
	WarehouseType,
} from "../../components/hoc_customer_master";
import KppCodeModal from "./cs_kpp_code";
import "./customer_master.css";

const CustomerMaster: React.FC<any> = ({
	form,
	generateNewCustomerCode,
	handleNew,
	customerTypes,
	showIdSection,
	setShowIdSection,
	idTypes,
	provinces,
	kabupatens,
	fetchKabupatens,
	kecamatans,
	fetchKecamatans,
	kelurahans,
	fetchKelurahans,
	sameAsIdAddressChecked,
	handleSameAsIdAddressChange,
	termOfPayments,
	taxInvoiceTypes,
	vatTransactionTypes,
	businessTypes,
	customerBehaviours,
	jobTitles,
	dealerNames,
	autosaveStatus,
	triggerAutosave,
	setAutosaveStatus,
	formatRupiahInput,
	parseRupiahInput,
	isKppModalVisible,
	showKppModal,
	handleKppModalOk,
	handleKppModalCancel,
	onSelectKpp,
	isActiveButtonDisabled,
	isDeactivateButtonDisabled,
	handleDeactivateCustomer,
	isCustomerTypeDisabled,
	handleActivateCustomer,
	similarNames,
	handleNameChange
}) => {
	const transformStyle = {
		transform: "scale(0.80)",
		transformOrigin: "top left",
		width: "125%",
	};

	return (
		<div id="iau9" style={transformStyle}>
			<div className="gjs-grid-row" id="inccj">
				<div className="gjs-grid-column" id="idrsu">
					<Breadcrumb
						items={[
							{
								href: "#/dashboard/data_customer_master",
								title: (
									<>
										<UserOutlined />
										<span>Data Customer</span>
									</>
								),
							},
							{
								title: "Customer Master",
							},
						]}
					/>
				</div>
			</div>
			<div className="gjs-grid-row" id="i8m7t">
				<div className="gjs-grid-column" id="i4lcb">
					<Form
						form={form}
						layout="horizontal"
						style={{ maxWidth: 590 }}
						labelCol={{ style: { width: "250px", textAlign: "left" } }}
						wrapperCol={{ style: { width: "290px" } }}
						className="custom-info-purchase-request"
						initialValues={{ record_status: initialRecordStatus }}
						preserve={true}
						onValuesChange={(changedValues, allValues) => {
							triggerAutosave(allValues);
						}}
					>
						<Button className="green-button" onClick={handleNew}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								style={{ width: "1em", height: "1em", marginRight: "8px" }}>
								<path
									fillRule="evenodd"
									d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
									clipRule="evenodd"
								/>
								<path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
							</svg>
							New
						</Button>
						<Button className="green-button" onClick={handleActivateCustomer} disabled={isActiveButtonDisabled}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								style={{ width: "1em", height: "1em", marginRight: "8px" }}>
								<path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
							</svg>
							Active
						</Button>
						<Button className="green-button" onClick={handleDeactivateCustomer} disabled={isDeactivateButtonDisabled}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								style={{ width: "1em", height: "1em", marginRight: "8px" }}>
								<path
									fillRule="evenodd"
									d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
									clipRule="evenodd"
								/>
							</svg>
							Deactive
						</Button>
						<Space style={{ marginLeft: '10px' }}>
							{autosaveStatus === 'processing' && (
								<Tooltip title="Autosave sedang berjalan...">
									<LoadingOutlined style={{ color: '#1890ff' }} />
								</Tooltip>
							)}
							{autosaveStatus === 'error' && (
								<Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
									<WarningOutlined style={{ color: '#ff4d4f' }} />
								</Tooltip>
							)}
							{autosaveStatus === 'stopped' && (
								<Tooltip title="Autosave Stop.">
									<StopOutlined style={{ color: '#bfbfbf' }} />
								</Tooltip>
							)}
							{autosaveStatus === 'idle' && (
								<Tooltip title="Autosave berhasil.">
									<CheckCircleOutlined style={{ color: '#52c41a' }} />
								</Tooltip>
							)}
						</Space>
						<Form.Item
							label="Record Status"
							name="record_status"
							style={{
								marginBottom: "5px",
							}}>
							<Input style={{ width: "100%" }} readOnly />
						</Form.Item>
						<Form.Item label="Customer Code" name="cs_code" style={{ marginBottom: "10px" }}>
							<Input readOnly />
						</Form.Item>
						<Form.Item label="Customer Type" name="customer_type" style={{ marginBottom: "5px" }} required>
							<Select
								showSearch
								placeholder="Select Customer Type"
								optionFilterProp="label"
								style={{ width: "100%" }}
								getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
								options={customerTypes.map((type: CustomerType) => ({
									value: type.code,
									label: type.deskripsi,
								}))}
								onChange={async (value, option) => {
									console.log("Customer Type selected:", value, option);

									if (value) {
										const existingCsCode = form.getFieldValue("cs_code");
										if (!existingCsCode) {
											await generateNewCustomerCode();
										}
										const currentValues = form.getFieldsValue();
										triggerAutosave(currentValues);
									} else {
										form.setFieldsValue({ cs_code: undefined, record_status: undefined });
										setAutosaveStatus('stopped');
									}
								}}
								disabled={isCustomerTypeDisabled}
							/>
						</Form.Item>
						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>ID</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={showIdSection} onChange={(e) => setShowIdSection(e.target.checked)} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							{showIdSection && (
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item label="ID Type" name="id_type" style={{ marginBottom: "5px" }} required>
										<Select
											showSearch
											placeholder="Select ID Type"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={idTypes.map((type: IdType) => ({
												value: type.code,
												label: type.deskripsi,
											}))}
										/>
									</Form.Item>

									<Form.Item
										label="ID No"
										name="id_no"
										style={{
											marginBottom: "5px",
										}}
										required
									>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Title Prefix"
										name="title_p"
										style={{
											marginBottom: "5px",
										}}
									>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Customer Name"
										name="cs_name"
										style={{
											marginBottom: "5px",
										}}
										required
									>
										<Input placeholder="" onChange={handleNameChange} />
									</Form.Item>
									<Form.Item
										label="Title Suffix"
										name="title_s"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Search Keyword"
										name="search_kw"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Address" style={{ marginBottom: "5px" }} required>
										<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
											<Form.Item name="address_line1" style={{ marginBottom: 0 }}>
												<Input.TextArea rows={3} />
											</Form.Item>
											<Form.Item name="address_line2" style={{ marginBottom: 0 }} hidden>
												<Input.TextArea rows={3} />
											</Form.Item>
										</div>
									</Form.Item>
									<Form.Item
										label="RT/RW"
										name="rt_rw"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Provinsi" name="provinsi" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Provinsi"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={provinces.map((prov: ProvinsiType) => ({
												value: prov.kode_provinsi,
												label: prov.nama_provinsi,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ kabupaten: undefined });
												fetchKabupatens(value);
											}}
										/>
									</Form.Item>
									<Form.Item label="Kabupaten" name="kabupaten" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Kabupaten"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kabupatens.map((kab: KabupatenType) => ({
												value: kab.kode_dati,
												label: `${kab.deskripsi_kode_dati}`,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ kecamatan: undefined, kelurahan: undefined, kode_pos: undefined });
												fetchKecamatans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kecamatan"
										name="kecamatan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Kecamatan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kecamatans.map((kec: KecamatanType) => ({
												value: kec.kode_kecamatan,
												label: kec.deskripsi_kode_kecamatan,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ kelurahan: undefined, kode_pos: undefined });
												fetchKelurahans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="kelurahan"
										name="kelurahan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select kelurahan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kelurahans.map((kel: KelurahanType) => ({
												value: kel.kode_kelurahan,
												label: kel.deskripsi_kode_kelurahan,
											}))}
											onChange={(value: string) => {
												const selectedKelurahan = kelurahans.find((kel: { kode_kelurahan: string }) => kel.kode_kelurahan === value);
												if (selectedKelurahan) {
													form.setFieldsValue({ kode_pos: selectedKelurahan.kode_pos });
													triggerAutosave(form.getFieldsValue());
												} else {
													form.setFieldsValue({ kode_pos: undefined });
													triggerAutosave(form.getFieldsValue());

												}
											}}
										/>
									</Form.Item>
									<Form.Item label="Kode Pos" name="kode_pos" style={{ marginBottom: "5px" }}>
										<Input readOnly />
									</Form.Item>
									<div className="grid-2">
										<Form.Item
											label="Email Address"
											name="email"
											style={{
												marginBottom: "5px",
											}}>
											<Input placeholder="" />
										</Form.Item>
										<Form.Item
											label="Mobile Phone"
											name="no_hp1"
											style={{
												marginBottom: "5px",
											}}>
											<Input placeholder="" />
										</Form.Item>
										<Form.Item
											label="Mobile Phone 2"
											name="no_hp2"
											style={{
												marginBottom: "5px",
											}}>
											<Input placeholder="" />
										</Form.Item>
										<Form.Item label="Term Of Payment" name="termofpayment" style={{ marginBottom: "5px" }}>
											<Select
												showSearch
												placeholder="Select Term Of Payment"
												optionFilterProp="label"
												style={{ width: "100%" }}
												getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
												options={termOfPayments.map((top: TermOfPaymentType) => ({
													value: top.code,
													label: top.deskripsi,
												}))}
											/>
										</Form.Item>
										<Form.Item label="Tax Invoice Type" name="taxinvoicetype" style={{ marginBottom: "5px" }}>
											<Select
												showSearch
												placeholder="Select Tax Invoice Type"
												optionFilterProp="label"
												style={{ width: "100%" }}
												getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
												options={taxInvoiceTypes.map((type: TaxInvoiceType) => ({
													value: type.code,
													label: type.deskripsi,
												}))}
											/>
										</Form.Item>
									</div>
								</div>
							)}
						</div>
						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>Home</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={true} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							<>
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item
										label="Same As ID Address"
										id="same_as_id_address"
										style={{
											marginBottom: "5px",
										}}>
										<div
											style={{
												gap: "0x",
												marginTop: "0px",
											}}></div>
										<Checkbox checked={sameAsIdAddressChecked} onChange={handleSameAsIdAddressChange}>Yes</Checkbox>
									</Form.Item>
									<Form.Item label="Address" style={{ marginBottom: "5px" }} required>
										<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
											<Form.Item name="home_address_line1" style={{ marginBottom: 0 }}>
												<Input.TextArea rows={3} />
											</Form.Item>
											<Form.Item name="home_address_line2" style={{ marginBottom: 0 }} hidden>
												<Input.TextArea rows={3} />
											</Form.Item>
										</div>
									</Form.Item>
									<Form.Item
										label="RT/RW"
										name="home_rtrw"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Provinsi" name="homeprovinsi" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Provinsi"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={provinces.map((prov: ProvinsiType) => ({
												value: prov.kode_provinsi,
												label: prov.nama_provinsi,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ homekabupaten: undefined, homekecamatan: undefined, homekelurahan: undefined, homekodepos: undefined });
												fetchKabupatens(value);
											}}
										/>
									</Form.Item>
									<Form.Item label="Kabupaten" name="homekabupaten" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Kabupaten"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kabupatens.map((kab: KabupatenType) => ({
												value: kab.kode_dati,
												label: `${kab.deskripsi_kode_dati}`,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ homekecamatan: undefined, homekelurahan: undefined, homekodepos: undefined });
												fetchKecamatans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kecamatan"
										name="homekecamatan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Kecamatan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kecamatans.map((kec: KecamatanType) => ({
												value: kec.kode_kecamatan,
												label: kec.deskripsi_kode_kecamatan,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ homekelurahan: undefined, homekodepos: undefined });
												fetchKelurahans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="kelurahan"
										name="homekelurahan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select kelurahan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kelurahans.map((kel: KelurahanType) => ({
												value: kel.kode_kelurahan,
												label: kel.deskripsi_kode_kelurahan,
											}))}
											onChange={(value: string) => {
												const selectedKelurahan = kelurahans.find((kel: { kode_kelurahan: string }) => kel.kode_kelurahan === value);
												if (selectedKelurahan) {
													form.setFieldsValue({ homekodepos: selectedKelurahan.kode_pos });
													triggerAutosave(form.getFieldsValue());
												} else {
													form.setFieldsValue({ homekodepos: undefined });
													triggerAutosave(form.getFieldsValue());

												}
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kode Pos"
										name="homekodepos"
										style={{
											marginBottom: "5px",
										}}>
										<Input readOnly />
									</Form.Item>
									<Form.Item
										label="Home Phone No"
										name="home_phone"
										style={{
											marginBottom: "5px",
											width: "78%",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Fax No"
										name="homefax_number"
										style={{
											marginBottom: "5px",
											width: "78%",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Phone Number"
										name="homehp"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
								</div>
							</>
						</div>
						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>Office</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={true} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							<>
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item label="Address" style={{ marginBottom: "5px" }} required>
										<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
											<Form.Item name="office_address_line1" style={{ marginBottom: 0 }}>
												<Input.TextArea rows={3} />
											</Form.Item>

											<Form.Item name="office_address_line2" style={{ marginBottom: 0 }} hidden>
												<Input.TextArea rows={3} />
											</Form.Item>
										</div>
									</Form.Item>
									<Form.Item
										label="RT/RW"
										name="office_rtrw"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Provinsi" name="officeprovinsi" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Provinsi"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={provinces.map((prov: ProvinsiType) => ({
												value: prov.kode_provinsi,
												label: prov.nama_provinsi,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({
													officekabupaten: undefined,
													officekecamatan: undefined,
													officekelurahan: undefined,
													officekodepos: undefined,
												});
												fetchKabupatens(value);
											}}
										/>
									</Form.Item>
									<Form.Item label="Kabupaten" name="officekabupaten" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Kabupaten"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kabupatens.map((kab: KabupatenType) => ({
												value: kab.kode_dati,
												label: `${kab.deskripsi_kode_dati}`,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ officekecamatan: undefined, officekelurahan: undefined, officekodepos: undefined });
												fetchKecamatans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kecamatan"
										name="officekecamatan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Kecamatan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kecamatans.map((kec: KecamatanType) => ({
												value: kec.kode_kecamatan,
												label: kec.deskripsi_kode_kecamatan,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ officekelurahan: undefined, officekodepos: undefined });
												fetchKelurahans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="kelurahan"
										name="officekelurahan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select kelurahan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kelurahans.map((kel: KelurahanType) => ({
												value: kel.kode_kelurahan,
												label: kel.deskripsi_kode_kelurahan,
											}))}
											onChange={(value: string) => {
												const selectedKelurahan = kelurahans.find((kel: { kode_kelurahan: string }) => kel.kode_kelurahan === value);
												if (selectedKelurahan) {
													form.setFieldsValue({ officekodepos: selectedKelurahan.kode_pos });
													triggerAutosave(form.getFieldsValue());
												} else {
													form.setFieldsValue({ officekodepos: undefined });
													triggerAutosave(form.getFieldsValue());

												}
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kode Pos"
										name="officekodepos"
										style={{
											marginBottom: "5px",
										}}>
										<Input readOnly />
									</Form.Item>
									<Form.Item
										label="Telp No"
										name="officetelpno"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Fax No"
										name="officefaxno"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Phone Number"
										name="officephoneno"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
								</div>
							</>
						</div>

						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>VAT</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={true} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							<>
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item
										label="NPWP"
										name="vatnpwp"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="NPWP Date"
										name="vatnpwpdate"
										style={{
											marginBottom: "5px",
										}}>
										<DatePicker
											format="DD/MM/YYYY"
											placeholder="Select date"
											style={{ width: "40%", fontSize: "14px" }}
											popupStyle={{ fontSize: "12px" }}
										/>
									</Form.Item>
									<Form.Item
										label="PKP"
										id="cek_pkp"
										style={{
											marginBottom: "5px",
										}}>
										<div
											style={{
												gap: "10px",
												marginTop: "0px",
												display: "flex",
											}}>
											<Checkbox>Yes</Checkbox>
											<Checkbox>No</Checkbox>
										</div>
									</Form.Item>
									<Form.Item
										label="PKP No"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="PKP Date"
										name="vatpkpdate"
										style={{
											marginBottom: "5px",
										}}>
										<DatePicker
											format="DD/MM/YYYY"
											placeholder="Select date"
											style={{ width: "40%", fontSize: "14px" }}
											popupStyle={{ fontSize: "12px" }}
										/>
									</Form.Item>
									<Form.Item label="VAT Transaction Code" name="vattransactioncode" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select VAT Transaction Code"
											optionFilterProp="label"
											style={{ width: "100%" }}
											dropdownStyle={{ width: "auto", minWidth: "500px" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={vatTransactionTypes.map((type: VatTransactionType) => ({
												value: type.code,
												label: `${type.code} - ${type.deskripsi}`,
											}))}
										/>
									</Form.Item>
									<Form.Item
										label="Name"
										name="vatname"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Address" style={{ marginBottom: "5px" }} required>
										<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
											<Form.Item name="vat_address1" style={{ marginBottom: 0 }}>
												<Input.TextArea rows={3} />
											</Form.Item>
										</div>
									</Form.Item>
									<Form.Item
										label="RT/RW"
										name="vat_rtrw"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Provinsi" name="vatprovinsi" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Provinsi"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={provinces.map((prov: ProvinsiType) => ({
												value: prov.kode_provinsi,
												label: prov.nama_provinsi,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ vatkabupaten: undefined, vatkecamatan: undefined, vatkelurahan: undefined, vatkodepos: undefined });
												fetchKabupatens(value);
											}}
										/>
									</Form.Item>
									<Form.Item label="Kabupaten" name="vatkabupaten" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Kabupaten"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kabupatens.map((kab: KabupatenType) => ({
												value: kab.kode_dati,
												label: `${kab.deskripsi_kode_dati}`,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ vatkecamatan: undefined, vatkelurahan: undefined, vatkodepos: undefined });
												fetchKecamatans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kecamatan"
										name="vatkecamatan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Kecamatan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kecamatans.map((kec: KecamatanType) => ({
												value: kec.kode_kecamatan,
												label: kec.deskripsi_kode_kecamatan,
											}))}
											onChange={(value: string) => {
												form.setFieldsValue({ vatkelurahan: undefined, vatkodepos: undefined });
												fetchKelurahans(value);
											}}
										/>
									</Form.Item>
									<Form.Item
										label="kelurahan"
										name="vatkelurahan"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select kelurahan"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={kelurahans.map((kel: KelurahanType) => ({
												value: kel.kode_kelurahan,
												label: kel.deskripsi_kode_kelurahan,
											}))}
											onChange={(value: string) => {
												const selectedKelurahan = kelurahans.find((kel: { kode_kelurahan: string }) => kel.kode_kelurahan === value);
												if (selectedKelurahan) {
													form.setFieldsValue({ vatkodepos: selectedKelurahan.kode_pos });
													triggerAutosave(form.getFieldsValue());
												} else {
													form.setFieldsValue({ vatkodepos: undefined });
													triggerAutosave(form.getFieldsValue());
												}
											}}
										/>
									</Form.Item>
									<Form.Item
										label="Kode Pos"
										name="vatkodepos"
										style={{
											marginBottom: "5px",
										}}>
										<Input readOnly />
									</Form.Item>
									<Form.Item label="KPP Code" style={{ marginBottom: "5px" }}>
										<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
											<Form.Item name="vatkppcode" noStyle>
												<Input placeholder="KPP Code" style={{ width: "40%" }} />
											</Form.Item>
											<Button
												id="cs_kpp_code"
												type="primary"
												icon={
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "30px", height: "25px", paddingTop: "2px" }}>
														<path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
														<path
															fillRule="evenodd"
															d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
															clipRule="evenodd"
														/>
														<path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
													</svg>
												}
												onClick={showKppModal}
											>
											</Button>

											<Form.Item noStyle name="vatkppdeskripsi">
												<Input placeholder="KPP Deskripsi" style={{ width: "100%" }} />
											</Form.Item>
										</div>
									</Form.Item>
								</div>
							</>
						</div>
						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>Corporate Customer</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={true} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							<>
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item label="Business Type" name="businesstype" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Business Type"
											optionFilterProp="label"
											style={{ width: "100%" }}
											dropdownStyle={{ width: "auto", minWidth: "500px" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={businessTypes.map((type: BusinessType) => ({
												value: type.code,
												label: type.deskripsi,
											}))}
										/>
									</Form.Item>
									<Form.Item label="Company Group" name="companygroup" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Company Group"
											optionFilterProp="label"
											style={{ width: "100%" }}
											dropdownStyle={{ width: "auto", minWidth: "500px" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Web Site"
										name="website"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
								</div>
							</>
						</div>
						<div className="grid-2">
							<Form.Item
								label={<span style={{ fontWeight: "600" }}>Customer Status</span>}
								style={{
									marginBottom: "0px",
								}}>
								<div
									style={{
										gap: "0px",
										marginTop: "0px",
									}}>
									<Checkbox checked={true} style={{ fontWeight: 600 }}>
										Show
									</Checkbox>
								</div>
							</Form.Item>
							<>
								<div style={{ paddingLeft: "20px" }}>
									<Form.Item
										label="Customer Class"
										name="customerclass"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item label="Customer Behaviour" name="customerbehaviour" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Customer Behaviour"
											optionFilterProp="label"
											options={customerBehaviours.map((cb: CustomerBehaviourType) => ({ value: cb.code, label: cb.deskripsi }))}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Gender"
										name="gender"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Gender"
											optionFilterProp="label"
											options={[
												{ value: "L", label: "Laki Laki" },
												{ value: "P", label: "Perempuan" },
												{ value: "X", label: "Lainnya" },
											]}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Birthday"
										name="birthday"
										style={{
											marginBottom: "5px",
										}}>
										<DatePicker
											format="DD/MM/YYYY"
											placeholder="Select date"
											style={{ width: "40%", fontSize: "14px" }}
											popupStyle={{ fontSize: "12px" }}
										/>
									</Form.Item>
									<Form.Item
										label="Religion"
										name="religion"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Religion"
											optionFilterProp="label"
											options={[
												{ value: "B", label: "BUDDHA" },
												{ value: "H", label: "HINDU" },
												{ value: "I", label: "ISLAM" },
												{ value: "KT", label: "KATOLIK" },
												{ value: "KR", label: "KRISTEN" },
											]}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Marital Status"
										name="maritalstatus"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Marital Status"
											optionFilterProp="label"
											options={[
												{ value: "M0", label: "Married has child" },
												{ value: "M1", label: "Married no child" },
												{ value: "S", label: "Single" },
												{ value: "DJ", label: "Duda/Janda" },
											]}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Marriage Date"
										name="marriagedate"
										style={{
											marginBottom: "5px",
										}}>
										<DatePicker
											format="DD/MM/YYYY"
											placeholder="Select date"
											style={{ width: "40%", fontSize: "14px" }}
											popupStyle={{ fontSize: "12px" }}
										/>
									</Form.Item>
									<Form.Item label="Job Title" name="jobtitle" style={{ marginBottom: "5px" }}>
										<Select
											showSearch
											placeholder="Select Job Title"
											optionFilterProp="label"
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											options={jobTitles.map((job: JobTitleType) => ({
												value: job.code,
												label: job.deskripsi,
											}))}
										/>
									</Form.Item>
									<Form.Item
										label="Hobby"
										name="hobby"
										style={{
											marginBottom: "5px",
										}}>
										<Input placeholder="" />
									</Form.Item>
									<Form.Item
										label="Note"
										name="note"
										style={{
											marginBottom: "5px",
										}}>
										<Input.TextArea rows={4} placeholder="Enter your Note here..." />
									</Form.Item>
									<Form.Item
										label="Correspondence Equal To"
										name="correspondence_equal_to"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Correspondence Equal To"
											optionFilterProp="label"
											options={[
												{ value: "", label: "- Empty -" },
												{ value: "01", label: "ID Address" },
												{ value: "02", label: "Home Address" },
												{ value: "03", label: "Office Address" },
											]}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Billing Equal To"
										name="billing_equal_to"
										style={{
											marginBottom: "5px",
										}}>
										<Select
											showSearch
											placeholder="Select Billing Equal To"
											optionFilterProp="label"
											options={[
												{ value: "", label: "- Empty -" },
												{ value: "01", label: "ID Address" },
												{ value: "02", label: "Home Address" },
												{ value: "03", label: "Office Address" },
											]}
											style={{ width: "100%" }}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</Form.Item>
									<Form.Item
										label="Print Statement"
										name="printstate"
										style={{
											marginBottom: "5px",
										}}>
										<div
											style={{
												gap: "10px",
												marginTop: "0px",
												display: "flex",
											}}>
											<Checkbox>Yes</Checkbox>
											<Checkbox>No</Checkbox>
										</div>
									</Form.Item>
									<Form.Item
										label="Credit Limit"
										name="credit_limit"
										style={{
											marginBottom: "5px",
										}}>
										<InputNumber
											placeholder=""
											style={{ width: "100%" }}
											formatter={formatRupiahInput}
											parser={parseRupiahInput}
											min={0}
										/>
									</Form.Item>
									<Form.Item
										label="Remaining Credit Limit"
										name="remaining_credit_limit"
										style={{
											marginBottom: "5px",
										}}>
										<InputNumber
											placeholder=""
											style={{ width: "100%" }}
											formatter={formatRupiahInput}
											parser={parseRupiahInput}
											min={0}
										/>
									</Form.Item>
								</div>
							</>
						</div>
						<Form.Item label="Warehouse" name="dealername" style={{ marginBottom: "5px" }}>
							<Select
								showSearch
								placeholder="Select Warehouse"
								optionFilterProp="label"
								style={{ width: "100%" }}
								getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
								options={dealerNames.map((dealer: WarehouseType) => ({
									value: dealer.warehouse_code,
									label: dealer.warehouse_name,
								}))}
							/>
						</Form.Item>
						<Form.Item
							label="Collector"
							name="collect"
							style={{
								marginBottom: "5px",
							}}>
							<Select
								showSearch
								placeholder="Select Collector"
								optionFilterProp="label"
								options={[{ value: "Empty", label: "Empty" }]}
								style={{ width: "100%" }}
								getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
							/>
						</Form.Item>
						<Form.Item
							label="Dealer Sales Rep"
							name="dealersalesrep"
							style={{
								marginBottom: "5px",
							}}>
							<Select
								showSearch
								placeholder="Select Dealer Sales Rep"
								optionFilterProp="label"
								options={[{ value: "Empty", label: "Empty" }]}
								style={{ width: "100%" }}
								getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
							/>
						</Form.Item>
						<Form.Item
							label="Contact Date"
							name="contactdate"
							style={{
								marginBottom: "5px",
							}}>
							<DatePicker format="DD/MM/YYYY" placeholder="Select date" style={{ width: "40%", fontSize: "14px" }} popupStyle={{ fontSize: "12px" }} />
						</Form.Item>
					</Form>
				</div>
			</div>
			<div className="gjs-grid-row" id="iaraa">
				<div className="gjs-grid-column" id="i6o6g">
					<div className="grid-2">
						<Form.Item
							label="Customer Ship To Add"
							style={{
								marginBottom: "0px",
							}}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}>
								<div
									style={{
										minWidth: "83px",
									}}></div>
								<Checkbox checked={true}>Show</Checkbox>
							</div>
						</Form.Item>
						<>
							<Table<DataTypeCSTA>
								columns={columns}
								style={{ paddingRight: "30px" }}
								dataSource={[]}
								className="table-gr"
								pagination={false}
								bordered
							/>
							<div style={{ marginTop: "20px", textAlign: "left" }}>
								<Space>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "105px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Add Line
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "100px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
											</svg>
										}>
										Active
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "120px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Deactive
									</Button>
								</Space>
							</div>
						</>
					</div>
					<div className="grid-2">
						<Form.Item
							label="Contact or PIC"
							style={{
								marginBottom: "0px",
							}}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}>
								<div
									style={{
										minWidth: "138px",
									}}></div>
								<Checkbox checked={true}>Show</Checkbox>
							</div>
						</Form.Item>
						<>
							<Table<DataTypeCOP>
								columns={columnsCOP}
								style={{ paddingRight: "30px" }}
								dataSource={[]}
								className="table-gr"
								pagination={false}
								bordered
							/>
							<div style={{ marginTop: "20px", textAlign: "left" }}>
								<Space>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "105px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Add Line
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "100px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
											</svg>
										}>
										Active
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "120px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Deactive
									</Button>
								</Space>
							</div>
						</>
					</div>
					<div className="grid-2">
						<Form.Item
							label="Bank"
							style={{
								marginBottom: "0px",
							}}>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}>
								<div
									style={{
										minWidth: "205px",
									}}></div>
								<Checkbox checked={true}>Show</Checkbox>
							</div>
						</Form.Item>

						<>
							<Table<DataTypeBank>
								columns={columnsBank}
								style={{ paddingRight: "30px" }}
								dataSource={[]}
								className="table-gr"
								pagination={false}
								bordered
							/>
							<div style={{ marginTop: "20px", textAlign: "left" }}>
								<Space>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "105px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Add Line
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "100px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
											</svg>
										}>
										Active
									</Button>
									<Button
										type="primary"
										style={{
											height: "40px",
											width: "120px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
										icon={
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
												<path
													fillRule="evenodd"
													d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
													clipRule="evenodd"
												/>
											</svg>
										}>
										Deactive
									</Button>
								</Space>
							</div>
						</>
					</div>
				</div>
			</div>
			<Modal
				title="KPP Code Lookup"
				open={isKppModalVisible}
				onOk={handleKppModalOk}
				onCancel={handleKppModalCancel}
				width={800}
				footer={null}
			>
				<KppCodeModal onSelectKpp={onSelectKpp} />
			</Modal>
		</div>
	);
};

export default withCustomerMasterLogic(CustomerMaster);
